import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { getFaq } from "./faqActions";
// import { FAQ_SHOWN } from "../../services/webengage/webEngageConstants";
import BreadCrumbs from "../../components/BreadCrumbs";
import FaqAccordion from "./FaqAccordion";
import styles from "./styles";
import dynamic from "next/dynamic";
import cns from "classnames";
const SnackBar = dynamic(() => import("../../components/Snackbar/index"), {
  ssr: false
});

class FaqList extends Component {
  state = {
    faqList: []
  };

  componentDidMount() {
    // this.props.logEvents(FAQ_SHOWN);
  }

  render() {
    const { classes, snackbar, breadcrumbList, faq, deviceType } = this.props;
    const { faqList = [] } = faq;
    const isMobile = deviceType === "mobile";
    return (
      <div className={classes.cont1}>
        <div className={classes.bannerBg}>
          <div className="cont1-left">
            <h1 className={classes.heading}>
              Recruiters self help guide (FAQs)
            </h1>
            <div className={classes.subHeading}>
              We have listed down some basic questions, you can always reach out
              at:{" "}
              <a
                className={classes.email}
                href="mailto:support@jobhai.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@jobhai.com
              </a>
            </div>
          </div>
          {!isMobile && (
            <div className={cns(classes.rightAlign, "cont1-right")}>
              <img
                src="/hire/faq-illustration.webp"
                alt="faq"
                className={classes.bannerImage}
              />
            </div>
          )}
        </div>
        <div className={classes.breadcrumbs}>
          <BreadCrumbs breadcrumbList={breadcrumbList} />
        </div>
        {faqList.length > 0 && <FaqAccordion faqList={faqList} />}
        {snackbar.snackBarState || snackbar.snackBarSuccessState ? (
          <SnackBar />
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  snackbar: state.snackbarReducer,
  faq: state.faqReducer.faq,
  deviceType: state.commonReducer.deviceType
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getFaq
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(FaqList));
